import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isHome = location.pathname === '/';
  const showWhiteNav = isScrolled || !isHome;
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Gallery',
    href: '/gallery'
  }, {
    name: 'Testimonials',
    href: '/testimonials'
  }, {
    name: 'Contact Us',
    href: '/booking'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${showWhiteNav ? 'bg-white py-4 shadow-md' : 'bg-transparent py-6'}`} data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-227">
        <div className="flex justify-between items-center" data-id="element-228">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-229">
            <div className="flex flex-col leading-tight" data-id="element-230">
              <span className={`font-script text-3xl md:text-4xl font-bold tracking-wide transition-colors ${showWhiteNav ? 'text-jet group-hover:text-burgundy' : 'text-golden group-hover:text-white'}`} data-id="element-231">
                Beni's
              </span>
              <span className={`text-[0.6rem] md:text-xs uppercase tracking-[0.25em] font-medium -mt-0.5 transition-colors ${showWhiteNav ? 'text-jet/60' : 'text-white/80'}`} data-id="element-232">
                African Braiding
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-233">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm uppercase tracking-wider font-medium transition-colors ${location.pathname === link.href ? showWhiteNav ? 'text-burgundy' : 'text-golden' : showWhiteNav ? 'text-jet hover:text-burgundy' : 'text-white hover:text-golden'}`} data-id="element-234">
                {link.name}
              </Link>)}
            <a href="tel:3013858034" data-id="element-235">
              <Button variant="primary" size="sm" data-id="element-236">
                Call Now
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 transition-colors ${showWhiteNav ? 'text-jet hover:text-burgundy' : 'text-golden hover:text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-237">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-238" /> : <MenuIcon className="h-6 w-6" data-id="element-239" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-240">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden shadow-lg" data-id="element-241">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-242">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`block px-3 py-4 font-medium text-lg border-b border-gray-100 ${location.pathname === link.href ? 'text-burgundy' : 'text-jet hover:text-burgundy'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-243">
                  {link.name}
                </Link>)}
              <div className="pt-6 px-3" data-id="element-244">
                <a href="tel:3013858034" className="block" data-id="element-245">
                  <Button variant="primary" className="w-full" onClick={() => setIsMobileMenuOpen(false)} data-id="element-246">
                    Call Now — 301-385-8034
                  </Button>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}